import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { NewsContainer, Hero, NewsGrid, NewsCard, NewsletterSection, PaginationContainer, PageButton } from './styles';
import { Button } from '../../components/Button';
import { BASE_API_URL_ENDPOINT, BASE_API_DOCUMENT } from '../../api/Api';
import toast, { Toaster } from "react-hot-toast";
import { getNewsTypeString } from '../../helpers/constant';
import axios from "axios";

const News = () => {
  const [loading, setLoading] = useState(false);
  const [news, setNews] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 6;

  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    if (isNaN(date)) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  };


  useEffect(() => {
    const fetchNews = async () => {
      try {
        const response = await axios.get(`${BASE_API_URL_ENDPOINT}news`);
        setNews(response.data.data);
      } catch (error) {
        console.error("Erreur de chargement des actualités :", error);
      }
    };

    fetchNews();
  }, []);

  // Calcul de la pagination
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentNews = news.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(news.length / itemsPerPage);

  const goToPage = (pageNumber) => {
    setCurrentPage(pageNumber);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);


    const form = e.target;
    const data = {
      email: form.email.value,
    };

    try {
      const res = await axios.post(`${BASE_API_URL_ENDPOINT}newsletter/subscribe`, data);
      if (res.data.success) {
        toast.success(res.data.message);
        form.reset();
      } else {
        toast.error(res.data.message);
      }
    } catch (err) {
      toast.error("Une erreur s'est produite lors de l'envoi du message.");
    } finally {
      setLoading(false);
    }
  };


  return (
    <NewsContainer>
      <Hero>
        <h1>Actualités</h1>
        <p>Restez informé de nos actions et de nos impacts</p>
      </Hero>

      <section className="container">
        <NewsGrid>
          {currentNews.map((item) => (
            <NewsCard key={item.id}>
              <div className="image">
                <img src={`${BASE_API_DOCUMENT}${item.image}`} alt={item.title} />
                <span className="category">{getNewsTypeString(item.category)}</span>
              </div>
              <div className="content">
                <span className="date">{formatDate(item.date)}</span>
                <h3>{item.title}</h3>
                <p>{item.excerpt}</p>
                <Button as={Link} to={`/news/${item.id}`}>Lire la suite</Button>
              </div>
            </NewsCard>
          ))}
        </NewsGrid>
        <PaginationContainer>
          {Array.from({ length: totalPages }, (_, i) => (
            <PageButton
              key={i}
              active={currentPage === i + 1}
              onClick={() => goToPage(i + 1)}
            >
              {i + 1}
            </PageButton>
          ))}
        </PaginationContainer>

      </section>

      <Toaster position="top-center" reverseOrder={false} />

      <NewsletterSection >
        <div className="container">
          <h2>Restez informé</h2>
          <p>Inscrivez-vous à notre newsletter pour recevoir nos dernières actualités</p>
          <form onSubmit={handleSubmit}>
            <input type="email" name="email" placeholder="Votre adresse email" required />
            {loading ? (
              <Button disabled>Envoi en cours...</Button>
            ) : (
              <Button $primary type="submit">S'inscrire</Button>
            )}
          </form>
        </div>
      </NewsletterSection>


    </NewsContainer>
  );
};

export default News;
